export default class {
    static percentage(partial, total) {
        return (100 * partial) / total;
    }
}
